export default __webpack_public_path__ + "static/media/sites15.d56c4930.png";